import { pm2SitemapStore, findPageDescriptorByPath, findCourseDescriptorFromParents } from '@pm2/sitemap-utils';
import { useLocation } from '@provider/navigation';

function useCurrentCourseDescriptor() {
  const sitemap = pm2SitemapStore.useSelector(state => state);
  const location = useLocation();
  const pageDescriptor = findPageDescriptorByPath(sitemap, location.pathname);
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, pageDescriptor);
  return courseDescriptor;
}

export { useCurrentCourseDescriptor };
//# sourceMappingURL=hook.current-course-descriptor.js.map
